import { useState } from 'react';

import { DialogTitle } from '@radix-ui/react-dialog';

import { Tag } from '@/components';
import { DialogContent } from '@/components/atoms/Dialog/Dialog';
import { Tabs } from '@/components/atoms/Tabs/Tabs';
import { DirectReportsData } from '@/types/account-settings';

import { DirectReportsTab } from './components/DirectReportsTab';
import { ProfileTab } from './components/ProfileTab';

export type UserProfileData = {
  managersName: string;
  timezone: string;
  language: string;
  dateFormat: string;
  tag: string;
  email: string;
  gender: string;
} & DirectReportsData;

type UserDetailsPopupProps = {
  user: UserProfileData;
  reports: DirectReportsData[];
};

export const UserDetailsPopup = ({ user, reports }: UserDetailsPopupProps) => {
  const [activeTab, setActiveTab] = useState('profile');

  const TABS = [
    {
      value: 'profile',
      label: 'Profile',
      content: <ProfileTab user={user} />,
    },
    {
      value: 'reports',
      label: 'Direct reports',
      content: <DirectReportsTab reports={reports} />,
    },
  ];

  return (
    <DialogContent showCloseButton>
      <div className="flex items-center gap-3">
        <img
          src={user.profileImageUrl}
          alt={user.name}
          width={24}
          height={24}
          className="rounded-full"
        />
        <DialogTitle className="text-xl font-semibold">{user.name}</DialogTitle>
        <Tag label={user.tag} size="small" color="cyan" />
      </div>
      <Tabs items={TABS} defaultValue="profile" value={activeTab} onValueChange={setActiveTab} />
    </DialogContent>
  );
};
